import React from 'react';
import classNames from "classnames";
import {
    ArenaConfiguration,
} from '../../../services/configurations/config-data-sections/arenas.configuration';
import {TopImageComponent} from '../../top-image/top-image.component';
import {LobbyHeaderComponent} from '../../lobby-header/lobby-header.component';
import {PcGameInfoPreviewComponent} from '../../lobby-game-info-preview/pc-game-info-preview/pc-game-info-preview.component';
import {observer} from 'mobx-react';
import {SeoBreadCrumbsComponent} from '../seo-bread-crumbs/seo-bread-crumbs.component';
import {IStickyHandler} from "../../sticky-handler/sticky-handler.interface";
import {ARENA_TYPES} from "./casino-arena.template-types";
import {LOBBY_PAGE} from '../../../themes/css-global-classes';
import {LobbyWrapperBox} from "../../../basic-components/lobby-wrapper/lobby-wrapper.box";
import {LobbyGridBox} from "../../../basic-components/lobby-grid/lobby-grid.box";
import {LinkToOfferComponent} from "../../link-to-offer/link-to-offer.component";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {ArenaGamesListsComponent} from "../../arena-games-lists/arena-games-lists.component";
import {DailyDealComponent} from "../../daily-deal/daily-deal.component";
import {FreeToPlayAnimatedIconComponent} from '../../free-to-play-animated-icon/free-to-play-animated-icon.component';


export interface LobbyArenaComponentProps {
    arenaName: string;
}

@observer
export class CasinoArenaComponent extends OrbitComponent<LobbyArenaComponentProps> {

    private _stickyHandler: IStickyHandler;

    private get stickyHandler(): IStickyHandler {
        if (!this._stickyHandler) {
            this._stickyHandler = this.services.stickyHandlerFactory.createStickyHandler();
        }
        return this._stickyHandler;
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        this.services.dom.body.classList.remove(LOBBY_PAGE);
        this.stickyHandler.dispose();
    }

    private get config(): ArenaConfiguration {
        return this.services.arenas.getArenaConfig(this.props.arenaName);
    }


    private _renderLinkToOffer() {
        return (
            <>
                <LinkToOfferComponent linkToOfferConfig={this.config.linkToOffer}/>
                <FreeToPlayAnimatedIconComponent/>
            </>
        );
    }



    render() {

        let sideBarInfo = {
            title: "",
            description: "",
            previewImage: ""
        };

        if (this.config.infoSideBar) {
            sideBarInfo = {
                title: this.config.infoSideBar.infoTitle,
                description: this.config.infoSideBar.infoText,
                previewImage: this.config.infoSideBar.infoImage
            };
        }

        return (
            <>
                <TopImageComponent image={this.config.topImage} altText={this.config.title} />
                <LobbyHeaderComponent
                    stickyHandler={this.stickyHandler}
                    showSearchIcon={true}
                    title={this.config.title}
                    arenaFiltersRenderingOptions={this.services.gamesFilter.renderPCFiltersIndicator()}>
                </LobbyHeaderComponent>

                <LobbyWrapperBox className={'cy-lobby-wrapper-arena'}>
                    <LobbyGridBox className={classNames('cy-lobby-grid-arena')}>
                        <ArenaGamesListsComponent key={this.props.arenaName} arenaName={this.props.arenaName}/>
                    </LobbyGridBox>
                    {
                        (this.config.arenaType !== ARENA_TYPES.WIDE_ARENA) && <PcGameInfoPreviewComponent stickyHandler={this.stickyHandler} arenaInfo={sideBarInfo} />
                    }
                    {this._renderLinkToOffer()}
                    <DailyDealComponent />
                </LobbyWrapperBox>

                <SeoBreadCrumbsComponent arenaName={this.props.arenaName} config={this.config.seoSection} />
            </>
        );
    }
}